"use client"

import { motion } from "framer-motion"
import Link from "next/link"
import { useState } from "react"
import { trackCTAClick } from "@/lib/analytics"
import { ANIMATION } from "@/lib/constants"
import { cn } from "@/lib/utils"

interface AnimatedCTALinkProps {
    href: string
    children: React.ReactNode
    className?: string
    target?: string
    rel?: string
}

export function AnimatedCTALink({
    href,
    children,
    className,
    target,
    rel,
}: AnimatedCTALinkProps) {
    const [isHovered, setIsHovered] = useState(false)

    return (
        <Link
            href={href}
            target={target}
            rel={rel}
            onClick={() => trackCTAClick("linkedin")}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className={cn(
                "group relative inline-flex h-12 items-center justify-center overflow-hidden rounded-full border border-border bg-background/50 px-8 font-medium text-sm transition-all duration-300 dark:border-border",
                className
            )}
        >
            <motion.div
                className="absolute inset-0 z-0 bg-foreground"
                initial={{ scaleX: 0, opacity: 0 }}
                animate={{
                    scaleX: isHovered ? 1 : 0,
                    opacity: isHovered ? 1 : 0,
                }}
                transition={{
                    duration: ANIMATION.duration.slow,
                    ease: "easeInOut",
                }}
                style={{ originX: 0.5 }}
            />
            <div className="relative z-10 flex items-center">
                <motion.span
                    animate={{
                        color: isHovered
                            ? "var(--background)"
                            : "var(--foreground)",
                    }}
                    transition={{ duration: ANIMATION.duration.normal }}
                    className="flex items-center"
                >
                    {children}
                </motion.span>
            </div>
        </Link>
    )
}
